// extracted by mini-css-extract-plugin
export var markdown = "_v3-0";
export var tableWrapper = "_v3-1";